import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, AUTH_ACTION_TYPE, MessageService } from "@obg/ngx.core";
import { groupSwitchMap } from "@obg/rxjs";
import { merge } from "lodash-es";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { GAME_VARIANT_ACTION_TYPE, GameVariantAction } from "./game-variant.action";
import { GetGameSettingsParams, GetGameVariantParams } from "./game-variant.model";
import { GameVariantService } from "./game-variant.service";

@Injectable()
export class GameVariantEffect {
	gameVariant$ = createEffect(() =>
		this.actions$.pipe(
			ofType(GAME_VARIANT_ACTION_TYPE.get),
			map((x: ActionWithPayload<GetGameVariantParams>) => x.payload),
			groupSwitchMap((params: GetGameVariantParams) =>
				this.service.get(params).pipe(
					map((response) =>
						this.action.getSuccess({
							gameVariant: response,
							jurisdiction: params.jurisdiction,
						})
					),
					catchError((error: AppError) => {
						const patchedError = merge(error, { data: { params } });
						return of(this.action.getFail(patchedError));
					})
				)
			)
		)
	);

	gameSettings$ = createEffect(() =>
		this.actions$.pipe(
			ofType(GAME_VARIANT_ACTION_TYPE.getSettings),
			map((x: ActionWithPayload<GetGameVariantParams>) => x.payload),
			groupSwitchMap((params: GetGameSettingsParams) =>
				this.service.getSettings(params).pipe(
					map((response) =>
						this.action.getSettingsSuccess({
							gameSettings: response,
						})
					),
					catchError((error: AppError) => {
						const patchedError = merge(error, { data: { params } });
						return of(this.action.getFail(patchedError));
					})
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[GAME_VARIANT_ACTION_TYPE.getFail]: GAME_VARIANT_ACTION_TYPE.get,
			})
		)
	);

	clearVariants$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AUTH_ACTION_TYPE.sessionEnd),
			map(() => this.action.clear())
		)
	);

	constructor(
		private actions$: Actions,
		private action: GameVariantAction,
		private service: GameVariantService,
		private messageService: MessageService
	) {}
}
